import {
	createResourceMutationDefinitions,
	deleteResourceMutationDefinitions,
	listResourceQueryDefinitions,
	updateResourceMutationDefinitions,
	viewResourceQueryDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const TARIFFS_LIST_QUERY = gql`
	query Tariffs($first: Int, $after: String) {
		tariffs(first: $first, after: $after) {
			nodes {
				tariffId
				name
				tariffTypeEnum
				flatRateAmount
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const TARIFF_QUERY = gql`
	query Tariff($id: Ulid!) {
		tariff(id: $id) {
			tariffId
			name
			tariffTypeEnum
			flatRateAmount
			tariffSteps {
				tariffStepId
				stepSequence
				intervalMinutes
				intervalCharge
				maxIntervals
			}
		}
	}
`;

// Separate query for references tab - lazy loaded
// Fetches pricing policies where this tariff is used as primary or overstay,
// vouchers that are bound to this tariff, and prepaid cards using this as default tariff
export const TARIFF_REFERENCES_QUERY = gql`
	query TariffReferences($tariffId: Ulid!) {
		pricingPoliciesAsPrimary: pricingPolicies(
			where: { tariffId: { eq: $tariffId } }
		) {
			nodes {
				tariffId
				pricingPolicyId
				name
				isActive
			}
		}
		pricingPoliciesAsOverstay: pricingPolicies(
			where: { overstayTariffId: { eq: $tariffId } }
		) {
			nodes {
				tariffId
				overstayTariffId
				pricingPolicyId
				name
				isActive
			}
		}
		vouchersWithTariff: vouchers(where: { tariffId: { eq: $tariffId } }) {
			nodes {
				tariffId
				voucherId
				name
				code
				isActive
			}
		}
		prepaidCardsWithTariff: prepaidCards(
			where: { defaultTariffId: { eq: $tariffId } }
		) {
			nodes {
				defaultTariffId
				prepaidCardId
				prepaidCode
				isActive
			}
		}
	}
`;

export const TARIFF_CREATE_MUTATION = gql`
	mutation CreateTariff($input: CreateTariffInput!) {
		createTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const TARIFF_UPDATE_MUTATION = gql`
	mutation UpdateTariff($input: UpdateTariffInput!) {
		updateTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const TARIFF_DELETE_MUTATION = gql`
	mutation DeleteTariff($input: DeleteTariffInput!) {
		deleteTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['tariffs'] = {
	document: TARIFFS_LIST_QUERY,
	dataPath: 'tariffs'
};

viewResourceQueryDefinitions['tariffs'] = {
	document: TARIFF_QUERY,
	dataPath: 'tariff'
};

createResourceMutationDefinitions['tariffs'] = {
	document: TARIFF_CREATE_MUTATION,
	operation: 'createTariff',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['tariffs'] = {
	document: TARIFF_UPDATE_MUTATION,
	operation: 'updateTariff',
	getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['tariffs'] = {
	document: TARIFF_DELETE_MUTATION,
	operation: 'deleteTariff',
	getVariables: variables => ({ input: variables })
};
